import { middlewareController } from '@cast/infrastructure-api';

import { auditLog } from './audit-log';
import { autoscaler } from './autoscaler';
import { clusterAutoscaler } from './cluster-autoscaler';
import { clusterManagement } from './cluster-management';
import { clusters } from './clusters';
import { costReport } from './cost-report';
import { inventory } from './inventory';
import { nodeConfigTemplates } from './node-config-templates';
import { omni } from './omni';
import { optimization } from './optimization';
import { pricing } from './pricing';
import { runtimeSecurity } from './runtime-security';
import { scheduledRebalancing } from './scheduled-rebalancing';
import { securityInsights } from './security-insights';
import { services } from './services';
import { stop } from './stop';
import { workloadEviction } from './workload-eviction';
import { workloadOptimization } from './workload-optimization';

export const activateDemoMiddleware = () => {
  middlewareController.addMiddleware('demo-middleware', {
    auditLog,
    autoscaler,
    clusters,
    clusterAutoscaler,
    clusterManagement,
    costReport,
    inventory,
    nodeConfigTemplates,
    omni,
    optimization,
    pricing,
    runtimeSecurity,
    scheduledRebalancing,
    securityInsights,
    services,
    stop,
    workloadEviction,
    workloadOptimization,
  });
};
